// UI
import { CardBody, CardWrapper } from "@/components/Card"
import { Heading } from "@/components/Typography"

// Translation
import { useTrans } from "@/i18n"

/**
 * AllProjectsDefaultRate
 * @returns
 */
export function AllProjectsDefaultRate() {
	const t = useTrans("dashboard")

	return (
		<CardWrapper className="mb-4">
			<CardBody>
				<Heading as="h5" className="mb-6 text-center sm:truncate">
					{t("dashboard:dashboard.default_rate.title")}
				</Heading>

				<div className="grid grid-cols-1 gap-6 md:grid-cols-3">
					<div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
						<div className="mb-4">
							<h6 className="text-lg font-semibold text-gray-900">
								{t(
									"dashboard:dashboard.default_rate.default_definition.title",
								)}
							</h6>
						</div>
						<p className="text-sm leading-relaxed text-gray-700">
							{t(
								"dashboard:dashboard.default_rate.default_definition.text",
							)}
						</p>
					</div>

					<div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
						<div className="mb-4">
							<h6 className="text-lg font-semibold text-gray-900">
								{t(
									"dashboard:dashboard.default_rate.unlikeliness_indicators.title",
								)}
							</h6>
						</div>
						<p className="text-sm leading-relaxed text-gray-700">
							{t(
								"dashboard:dashboard.default_rate.unlikeliness_indicators.text",
							)}
						</p>
					</div>

					<div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
						<div className="mb-4">
							<h6 className="text-lg font-semibold text-gray-900">
								{t(
									"dashboard:dashboard.default_rate.payment_schedule.title",
								)}
							</h6>
						</div>
						<p className="text-sm leading-relaxed text-gray-700">
							{t(
								"dashboard:dashboard.default_rate.payment_schedule.text",
							)}
						</p>
					</div>
				</div>
			</CardBody>
		</CardWrapper>
	)
}
